<template>
  <div>
    <h3 class="font-weight-bold text-center">
      Tab {{ order.TabNo }}
      <span v-if="order.OrderTypeID === 2">
        {{ " - " + order.TableNumber }}
      </span>
    </h3>
    <div class="d-flex flex-row justify-content-between my-2">
      <span class="text-muted font-weight-bold"
        >Net Sub Total
        <span
          style="color: gray"
          v-if="order.Credit !== null && order.Credit !== 0"
        >
          {{ "(with $" + order.Credit.toFixed(2) + " credit)" }}
        </span>
      </span>

      <span class="text-muted" v-if="order.Subtotal !== null">
        <span v-if="order.SplitType === 'Amount'">
          ${{ Number(order.Subtotal_adj).toFixed(2) }}
        </span>
        <span v-else> ${{ Number(order.Subtotal).toFixed(2) }} </span>
      </span>
    </div>

    <div class="d-flex flex-row justify-content-between my-2">
      <span class="text-muted font-weight-bold"
        >Tax
        <template v-if="order.IsSplit && order.SplitType === 'Amount' && order.OrderID !== order.OriginalOrderID">
        </template>
        <template v-else>
          <span v-if="order.Tax_Alc && order.Tax_Alc !== 0">
            (including ${{ +order.Tax_Alc.toFixed(2) }} Alcohol Tax)
          </span>
        </template>
      </span>
      <span class="text-muted" v-if="order.Tax !== null">
        <span v-if="order.SplitType === 'Amount'">
          ${{ Number(order.Tax_adj).toFixed(2) }}
        </span>
        <span v-else> ${{ Number(order.Tax).toFixed(2) }} </span>
      </span>
    </div>
    <div class="d-flex flex-row justify-content-between my-2">
      <span class="text-muted font-weight-bold"
        >Tip ({{ (100 * order.Tip_Percentage).toFixed(2) }}%)</span
      >
      <span class="text-muted" v-if="order.Tip !== null"
        >${{ order.Tip.toFixed(2) }}</span
      >
    </div>
    <div
      v-if="order.OrderTypeID === 3 && order.Delivery_Fee !== 0"
      class="d-flex flex-row justify-content-between my-2"
    >
      <span class="text-muted font-weight-bold">Delivery Fee</span>
      <span class="text-muted" v-if="order.Delivery_Fee !== null"
        >${{ order.Delivery_Fee.toFixed(2) }}</span
      >
    </div>
    <div v-if="!order.RestaurantPaid" class="d-flex flex-row justify-content-between my-2">
      <span class="text-muted font-weight-bold">Restaurant Total</span>
      <span class="text-muted" v-if="order.RestaurantTotal"
        >${{ order.RestaurantTotal.toFixed(2) }}</span
      >
    </div>
    <div
      v-else-if="order.Total - order.Fee != '0' && order.PaymentStatusID !== 4"
      class="d-flex flex-row justify-content-between my-2"
      style="opacity: 0.5"
    >
      <span class="text-muted font-weight-bold">Customer Charge</span>
      <span class="text-muted" v-if="order.Total !== null"
        >${{ order.Total.toFixed(2) }}</span
      >
    </div>

    <div
      v-if="order.Total - order.Fee && order.PaymentStatusID !== 4"
      class="d-flex flex-row justify-content-between my-2"
      style="opacity: 0.5"
    >
      <span class="text-muted font-weight-bold">Tech Fee</span>
      <span class="text-muted" v-if="order.Fee !== null"
        >${{ order.Fee.toFixed(2) }}</span
      >
    </div>
    <div
      v-if="order.Total - order.Fee != '0' && order.PaymentStatusID !== 4 && !order.RestaurantPaid"
      class="d-flex flex-row justify-content-between my-2"
      style="opacity: 0.5"
    >
      <span class="text-muted font-weight-bold">Customer Charge</span>
      <span class="text-muted" v-if="order.Total !== null"
        >${{ order.Total.toFixed(2) }}</span
      >
    </div>
    <div v-else-if="order.RestaurantPaid" class="d-flex flex-row justify-content-between my-2">
      <span class="text-muted font-weight-bold">Restaurant Total</span>
      <span class="text-muted" v-if="order.RestaurantTotal"
        >${{ order.RestaurantTotal.toFixed(2) }}</span
      >
    </div>


    <div
      v-if="order.PaymentStatusID === 4"
      class="d-flex flex-row justify-content-between my-2"
    >
      <span class="text-muted font-weight-bold">Customer Paid</span>
      <span class="text-muted" v-if="order.Total"
        >${{ (order.Total - order.Fee).toFixed(2) }}</span
      >
    </div>

    <div
      v-if="order.Refund !== 0"
      class="d-flex flex-row justify-content-between my-2"
    >
      <span class="text-danger font-weight-bold">Refunded</span>
      <span class="text-danger">${{ order.Refund.toFixed(2) }}</span>
    </div>
    <div v-if="order.ExemptionNo" class="text-danger font-weight-bold text-center">
      Tax Exemption Applied
    </div>
  </div>
</template>

<script>
export default {
  name: "orderInformation",
  props: {
    order: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
